import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "app-cookie__icon",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#F7EDE2\" fill-rule=\"evenodd\" d=\"M13 .036c.55-.04.996.414 1.035.965.49 6.934 6.03 12.475 12.965 12.964.55.04 1.004.485.965 1.036-.513 7.265-6.57 13-13.965 13-7.732 0-14-6.269-14-14C0 6.604 5.735.547 13 .035Z\" clip-rule=\"evenodd\"></path><circle cx=\"4.084\" cy=\"16.916\" r=\"1.75\" fill=\"#26434B\"></circle><circle cx=\"10.501\" cy=\"21.001\" r=\"1.167\" fill=\"#26434B\"></circle><circle cx=\"22.167\" cy=\"3.501\" r=\"1.167\" fill=\"#F7EDE2\"></circle><circle cx=\"23.916\" cy=\"8.75\" r=\"1.75\" fill=\"#F7EDE2\"></circle><circle cx=\"22.75\" cy=\"16.916\" r=\"1.75\" fill=\"#26434B\"></circle><circle cx=\"13.417\" cy=\"14.583\" r=\"2.917\" fill=\"#26434B\"></circle><circle cx=\"16.917\" cy=\"22.751\" r=\"2.917\" fill=\"#26434B\"></circle>", 8)
const _hoisted_10 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_10]))
}
export default { render: render }